import { FormEvent, ReactElement, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import NewButton from "../../../components/Atomos/Buttons/newButton";
import { SecondmentCatalogResult } from "../../../Services/PublicSecondments";

interface SecondmentsSearchFormProps {
  options: SecondmentCatalogResult["options"] | null;
}

export default function SecondmentsSearchForm({ options }: SecondmentsSearchFormProps): ReactElement {
  const [params, setParams] = useSearchParams();
  const formRef = useRef<HTMLFormElement>(null);
  const [words, setWords] = useState(params.get("words") || "");
  const [firm, setFirm] = useState(params.get("firm") || "-99");
  const [jurisdiction, setJurisdiction] = useState(params.get("jurisdiction") || "-99");
  const [region, setRegion] = useState(params.get("region") || "-99");

  function onSubmit(event: FormEvent): void {
    event.preventDefault();
    const next = new URLSearchParams();
    next.set("action", "search");
    if (words.trim() && words.trim().toLowerCase() !== "keyword search") {
      next.set("words", words.trim());
    }
    next.set("firm", firm);
    next.set("jurisdiction", jurisdiction);
    next.set("region", region);
    setParams(next);
  }

  return (
    <form ref={formRef} className="secondments-search" onSubmit={onSubmit}>
      <input name="words" type="search" placeholder="Keyword Search" value={words} onChange={(event) => setWords(event.target.value)} />
      <select value={firm} onChange={(event) => setFirm(event.target.value)} aria-label="Select a Firm">
        <option value="-99">Select a Firm</option>
        {(options?.firms ?? []).map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
      </select>
      <select value={jurisdiction} onChange={(event) => setJurisdiction(event.target.value)} aria-label="Select a Jurisdiction">
        <option value="-99">Select a Jurisdiction</option>
        {(options?.jurisdictions ?? []).map((item) => <option key={`${item.value}-${item.label}`} value={item.value}>{item.label}</option>)}
      </select>
      <select value={region} onChange={(event) => setRegion(event.target.value)} aria-label="Select a Region">
        <option value="-99">Select a Region</option>
        {(options?.regions ?? []).map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
      </select>
      <NewButton text="Search" color="primary" style="filled" onClick={() => formRef.current?.requestSubmit()} />
    </form>
  );
}
